import { TextFormatter } from "@/lib/text-formatter";

const StatusBadge = ({ status }: { status: string }) => {
  const statusColors = {
    Active: "bg-green-100 text-green-800 border-green-200",
    Inactive: "bg-red-100 text-red-800 border-red-200",
    Pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
    Confirmed: "bg-indigo-100 text-indigo-800 border-indigo-200",
    Shipped: "bg-emerald-100 text-emerald-800 border-emerald-200",
    "In Transit": "bg-blue-100 text-blue-800 border-blue-200",
    Delivered: "bg-green-100 text-green-800 border-green-200",
    Cancelled: "bg-red-100 text-red-800 border-red-200",
    Preparing: "bg-yellow-100 text-yellow-800 border-yellow-200",
    PENDING: "bg-yellow-100 text-yellow-800 border-yellow-200",
    IN_TRANSIT: "bg-blue-100 text-blue-800 border-blue-200",
    DELIVERED: "bg-green-100 text-green-800 border-green-200",
    CANCELLED: "bg-red-100 text-red-800 border-red-200",
    DRAFT: "bg-gray-100 text-gray-800 border-gray-200",
    PREPARING: "bg-orange-100 text-orange-800 border-orange-200",
    SUBMITTED: "bg-teal-100 text-teal-800 border-teal-200",
    CONFIRMED: "bg-blue-100 text-blue-800 border-blue-200",
    SHIPPED: "bg-purple-100 text-purple-800 border-purple-200",
    RECEIVED: "bg-green-100 text-green-800 border-green-200",
    VERIFIED: "bg-green-100 text-green-800 border-green-200",
    REJECTED: "bg-red-100 text-red-800 border-red-200",
    PENDING_VERIFICATION: "bg-yellow-100 text-yellow-800 border-yellow-200",
    Yes: "bg-green-100 text-green-800 border-green-200",
    No: "bg-red-100 text-red-800 border-red-200",
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium border ${
        statusColors[status as keyof typeof statusColors] ||
        "bg-gray-100 text-gray-800 border-gray-200"
      }`}
    >
      {TextFormatter.autoFormat(status)}
    </span>
  );
};

export default StatusBadge;
